import React from 'react'

export default function PorfolioPage({name}) {
    return (
        <div style={{paddingTop: 300}}>
            {name}
        </div>
    )
}
